var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"s-viewer-logo"},[_c('img',{attrs:{"id":"sViewerLogo","src":require("../../assets/logo.png"),"alt":"sViewerLogo"}})])
}]

export { render, staticRenderFns }